<div *ngIf="enrollment" class="card d-flex flex-column justify-content-center align-items-center h-100 w-100 p-3 mb-3">

    <div class="row w-100">

        <div class="col-12 col-xl-6">

            <div class="d-flex flex-column justify-content-center align-items-start">

                <span class="fs-4">Inscripción {{ enrollment.enrollmentCode }}</span>
                <span class="text-muted mb-0">Participante: {{ enrollment.studentName }} {{ enrollment.studentSurname }}</span>
                <span class="text-muted mb-0">Edición: {{ enrollment.editionDescription }}</span>
                <span class="text-muted mb-0">Precio: {{ enrollment.paymentInfo.finalPriceEnrollment }} €</span>

                <div *ngIf="enrollment.paymentInfo" class="card my-2">

                    <div *ngIf="!this.enrollment.paid" class="bg-accent-color d-flex flex-row justify-content-start align-items-center h-100 p-2">
                        <fa-icon [icon]="['fas', 'credit-card']" class="me-2"></fa-icon>
                        <span>Pendiente de pago</span>
                    </div>

                    <div *ngIf="this.enrollment.paid" class="bg-primary-color d-flex flex-row justify-content-start align-items-center h-100 p-2">
                        <fa-icon [icon]="['fas', 'receipt']" class="me-2"></fa-icon>
                        <span>Pagada</span>
                    </div>

                </div>

            </div>

        </div>

        <div class="col-12 col-xl-6">

            <div class="d-flex flex-column justify-content-center align-items-start align-items-xl-end w-100">
                <button pButton class="btn button-primary-color" title="Ver detalle"
                    (click)="goToDetail(enrollment.enrollmentCode)">
                    <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
                </button>
            </div>

        </div>

    </div>

</div>
